var App = App || {};

App.HomepageBanner = (function ($) {
    "use strict";

    function init() {
        var hpBanner = $(".homepage-banner-content-wrapper");
        var hpCards = $(".component-homepage-banner .homepage-banner-inner a.feature-card");
        hpBanner.hover(
            function () {
                hpCards.addClass("hovered-card");
            }
        );

        hpCards.hover(
            function () {
                $(this).addClass("hovered-card");
            }
        );

        hpCards.focusin(function () {
            $(this).addClass("hovered-card");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.HomepageBanner.init();
});